module.exports = __webpack_public_path__ + "resources/img/img_security_chakramax_sac.e0509cb216fdb2ea3b1f73bdbdc90edc.png";